import { useTranslation } from 'react-i18next';
import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
import { Navigate } from 'react-router-dom';
import { canViewTimedLevelPage } from '../../components/layout/AppLayout';
import { useAuthStore } from '../../store/auth.store';
import TimedSettlementLevelsPanel from './TimedSettlementLevelsPanel';

export default function TimedSettlementLevelsPage() {
  const { t } = useTranslation('tournament');
  const visiblePages = useAuthStore((state) => state.visiblePages);
  if (!visiblePages) return null;
  if (!canViewTimedLevelPage(visiblePages)) {
    return <Navigate to={visiblePages[0] ?? '/'} replace />;
  }
  return (
    <AdminPage>
      <AdminPageHeader title={t('timedLevels.title')} description={t('timedLevels.description')} />
      <TimedSettlementLevelsPanel showHeading={false} />
    </AdminPage>
  );
}
